import { useSearchParams } from "react-router-dom";
import _ from "lodash";
import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import Promise from "bluebird";
import { Box, Stack, Typography, Button } from "@mui/material";
import Logo from "../../utils/Logo";
import { useDeviceType } from "../../utils/hooks";

const DownloadMedicalDocuments = () => {
  const [searchParams] = useSearchParams();
  const urlsString = searchParams.get("urls");
  const urls = _.split(urlsString, "____");
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloaded, setDownloaded] = useState(false);
  const deviceType = useDeviceType();
  const isIOS = deviceType === 'ios';
  
  const autoDownload = !isIOS || _.size(urls) == 1

  const toUrlName = url => {
    const match = url.match(/\/prescriptions\/(\d+)/);
    return match ? parseInt(match[1]) : null;
  };

  const handleDownload = (urls) => {    
    setIsDownloading(true);

    Promise.each(urls, (url, index) => {
      const id = toUrlName(url) || index;
      const fileName = `${id}.pdf`;
      
      return fetch(`${url}&download=true`)
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, fileName);
        })
      })
      .then(() => setDownloaded(true))
      .finally(() => setIsDownloading(false));
  };

  useEffect(() => {
    if (_.isEmpty(urls) || downloaded || isDownloading) return;

    if (autoDownload) {
      handleDownload(urls);
    }
  }, [urls, downloaded, isDownloading, isIOS]);

  if (_.isEmpty(urls)) return;

  return (
    <Stack>
      <Box
        sx={{
          p: 8,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Logo width={"80px"} />
      </Box>
      <Typography variant="h6" textAlign="center" p={4}>
        {!autoDownload && (
          _.map(urls, (url) => {
            return (
              <Button 
                variant="contained" 
                color="primary" 
                onClick={() => handleDownload([url])}
                disabled={isDownloading}
                sx={{ mb: 2 }}
                key={url}
              >
                {`Descargar prescripción ${toUrlName(url)}`}
              </Button>
            )
          })
        )}
        {isDownloading && autoDownload && <div>Descargando prescripciones...</div>}
        {downloaded && autoDownload && <div>Descarga completa! Ya podés cerrar esta pestaña.</div>}
      </Typography>
    </Stack>
  );
};

export default DownloadMedicalDocuments;
